import { Paper, ThemeProvider } from "@material-ui/core";
import MaterialTable from "material-table";
import React from "react";
import { TableIcons } from "../../../../../utils/TableIcons";

function SignableDocumentsTable({
  resources,
  tableTheme,
  data,
  columns,
  actions,
  options,
}) {
  return (
    <Paper>
      <ThemeProvider theme={tableTheme}>
        <MaterialTable
          icons={TableIcons}
          title=""
          localization={{
            header: { actions: resources["Actions"] },
            body: {
              emptyDataSourceMessage: resources["NoRecordsToBeDisplayed"],
              deleteTooltip: resources["DeleteTooltip"],
              editTooltip: resources["EditTooltip"],
            },
            toolbar: {
              searchPlaceholder: resources["Search"],
              searchTooltip: resources["Search"],
            },
            pagination: {
              firstTooltip: resources["FirstTooltip"],
              lastTooltip: resources["LastTooltip"],
              previousTooltip: resources["PreviousTooltip"],
              nextTooltip: resources["NextTooltip"],
              labelRowsPerPage: resources["LabelRowsPerPage"],
              labelRowsSelect: resources["LabelRowsSelect"],
            },
          }}
          data={data}
          columns={columns}
          actions={actions}
          options={options}
        />
      </ThemeProvider>
    </Paper>
  );
}

export default SignableDocumentsTable;
